/**
 * Bulk-order notice — shows the panel when quantity >= min_qty on a variant
 * priced >= min_price. Closing it hides it for the current page view only; a
 * reload or a new page re-evaluates the trigger from scratch. One per form.
 */
(function () {
  'use strict';
  function init() {
    var notice = document.querySelector('.bulk-order-notice');
    if (!notice) return;
    var block = notice.closest('.buy-buttons-block');
    var form = block ? block.querySelector('.js-product-form-main') : null;
    var qty = form ? form.querySelector('input[name="quantity"]') : null;
    if (!form || !qty) return;

    var dismissed = false; // page-view only, deliberately not persisted
    var minQty = Number(notice.getAttribute('data-min-qty')) || 2;
    var minPrice = Number(notice.getAttribute('data-min-price')) || 0; // cents

    function update() {
      var price = Number(notice.getAttribute('data-variant-price') || minPrice);
      var show = Number(qty.value) >= minQty && price >= minPrice && !dismissed;
      notice.hidden = !show;
    }

    qty.addEventListener('change', update);
    qty.addEventListener('input', update);
    // quantity-input.js fires 'change' after +/- clicks; this covers the same tick.
    form.addEventListener('click', function (e) {
      if (e.target.closest('.qty-input__btn')) setTimeout(update, 0);
    });
    document.addEventListener('on:variant:change', function (e) {
      var v = e.detail && e.detail.variant;
      if (v && typeof v.price !== 'undefined') notice.setAttribute('data-variant-price', v.price);
      update();
    });
    var close = notice.querySelector('.bulk-order-notice__close');
    if (close) close.addEventListener('click', function () { dismissed = true; update(); });
    update();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
